// Hardcoded email whitelist for Quick Fill feature
const WHITELISTED_EMAILS = [
    'lucas.henriques@mjv.com.br',
    'sidney.outeiro@mjv.com.br',
    'julia.cunha@mjv.com.br',
    'carolina.sonda@mjv.com.br',
    'franklin.silverio@mjv.com.br'
];

/**
 * Checks if a user's email is in the whitelist
 * @param {string} email - The user's email address
 * @returns {boolean} - True if email is whitelisted, false otherwise
 */
export const isEmailWhitelisted = (email) => {
    if (!email) return false;
    return WHITELISTED_EMAILS.includes(email.toLowerCase());
};

